import React, { lazy, Suspense } from 'react';
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import { reactSelectStyle } from '../../componentStyles';
import Pagination from '../commonComponents/pagination';
import { getNumberOfCarsPerPage, scrollPageToTop } from '../../utilites';
import {
  NUMBER_OF_CARS_PER_PAGE,
  NEWEST_FIRST,
  CHEAP_FIRST,
  EXPENSIVE_FIRST,
  // A_Z,
  // Z_A,
  GRID_STYLE,
  LIST_STYLE,
  DELAY,
} from '../../constants';
import sortCarsArray from '../../redux/actions/catalogSort';
import setViewStyle from '../../redux/actions/catalogStyle';
import setActivePage from '../../redux/actions/pagination';
import setShowCars from '../../redux/actions/carCard';
import CatalogSearchForm from './catalogSearchForm';
import PopularBrands from './popularBrands';

const CarCard = lazy(() => import('../commonComponents/carCard'));

export default () => {
  const cars = useSelector((state) => state.catalog.cars);
  const activePage = useSelector((state) => state.pagination.activePage);
  const catalogStyle = useSelector((state) => state.catalogStyle.style);
  const orderedBy = useSelector((state) => state.catalog.orderedBy);
  const showCarCards = useSelector((state) => state.catalog.showCarCards);

  const dispatch = useDispatch();

  const firstCarOnPage = activePage * NUMBER_OF_CARS_PER_PAGE;
  const LastCarOnPage = getNumberOfCarsPerPage(cars, firstCarOnPage);
  const numberOfCars = ` ${cars.length}`;

  const { dictionary } = startup;

  const sortCarsOrder = (option) => {
    dispatch(sortCarsArray(cars, option.value));
    dispatch(setActivePage(0));
  };
  return (
    <div className="row">
      <div className="col-lg-3">
        <aside className="l-sidebar">
          <CatalogSearchForm />
          <section className="widget b-brands section-sidebar">
            <h3 className="widget-title popular-brands bg-dark">
              <i className="ic flaticon-car-4" />
              {dictionary.PopularBrands}
            </h3>
            <div>
              <div className="b-brands__main d-flex flex-wrap">
                <PopularBrands />
              </div>
            </div>
          </section>
        </aside>
      </div>
      <div className="col-lg-9">
        <div className="b-filter-goods">
          <div className="row justify-content-between align-items-center">
            <div className="b-filter-goods__wrap col-auto">
              <div className="b-filter-goods__select">
                <Select
                  // select order
                  styles={reactSelectStyle}
                  className="catalogFilter brand"
                  options={[
                    NEWEST_FIRST,
                    CHEAP_FIRST,
                    EXPENSIVE_FIRST,
                    // A_Z,
                    // Z_A,
                  ].map((el) => ({ value: el, label: dictionary[el] }))}
                  defaultValue={{
                    value: orderedBy,
                    label: dictionary[orderedBy],
                  }}
                  onChange={(carList, option) => {
                    dispatch(setShowCars(false));
                    setTimeout(() => sortCarsOrder(carList, option), DELAY);
                    scrollPageToTop();
                  }}
                />
              </div>
            </div>
            <div className="b-filter-goods__info col-auto">
              {dictionary.ShowingResults}
              <strong>
                {` ${firstCarOnPage + 1} ${
                  dictionary.To_From_Catalog_Header
                } ${LastCarOnPage} `}
              </strong>
              {dictionary.Of}
              <strong>{numberOfCars}</strong>
            </div>
            <div className="btns-switch col-auto">
              <button
                type="button"
                className={
                  catalogStyle === LIST_STYLE
                    ? 'btns-switch__item js-view-list ic fa fa-th-list active'
                    : 'btns-switch__item js-view-list ic fa fa-th-list'
                }
                onClick={() => {
                  dispatch(setViewStyle(LIST_STYLE));
                }}
              />
              <button
                type="button"
                className={
                  catalogStyle === GRID_STYLE
                    ? 'btns-switch__item js-view-th active ic fa fa-th'
                    : 'btns-switch__item js-view-th ic fa fa-th'
                }
                onClick={() => {
                  dispatch(setViewStyle(GRID_STYLE));
                }}
              />
            </div>
          </div>
        </div>
        <main className="b-goods-group row">
          <Suspense
            fallback={<p style={{ margin: '20px auto' }}>Still Loading…</p>}
          >
            <CarCard />
          </Suspense>
        </main>
        <nav
          aria-label="Page navigation"
          className={showCarCards ? 'pagination-nav' : 'pagination-nav-hidden'}
        >
          <ul className="pagination justify-content-center">
            <Pagination />
          </ul>
        </nav>
      </div>
    </div>
  );
};
